import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const FinalCTA = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 bg-[#3B4BA0] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-10 right-10 w-64 h-64 bg-white/10 rounded-full blur-3xl" />
      <div className="absolute bottom-10 left-10 w-96 h-96 bg-blue-400/10 rounded-full blur-3xl" />

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
          Ready to Help Your Child Read with Confidence?
        </h2>
        <p className="text-xl text-blue-50 leading-relaxed mb-10 max-w-2xl mx-auto">
          Whether you are a parent, teacher, or aspiring educator, Read Right Academy 
          is here to guide you step by step.
        </p>
        <Button
          size="lg"
          onClick={scrollToContact}
          className="bg-white text-[#3B4BA0] hover:bg-gray-100 text-lg px-10 py-6 shadow-2xl hover:shadow-3xl transition-all duration-300 group"
        >
          Contact Read Right Academy
          <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
        </Button>
      </div>
    </section>
  );
};

export default FinalCTA;